import React from "react";

export default () => {
  return <div>Pedro</div>;
};
